import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "skills-grid" }

import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import FeatureCard from "@/components/FeatureCard.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'SkillsSection',
  setup(__props) {

const skills = [
  {
    name: 'PHP & Laravel',
    icon: 'laravel-original.svg',
    description: 'Backend-Entwicklung mit Fokus auf saubere APIs, DDD und Performance in Laravel'
  },
  {
    name: 'Vue.js',
    icon: 'vuejs-plain.svg',
    description: 'Frontend-Entwicklung mit Vue 3 und der Composition API für moderne SPAs'
  },
  {
    name: 'TypeScript',
    icon: 'typescript-plain.svg',
    description: 'Für robustere Frontends, besseres Refactoring und weniger Laufzeitfehler'
  },
  {
    name: 'Docker',
    icon: 'docker-plain.svg',
    description: 'Containerisierung für eine einheitliche Entwicklungsumgebung'
  },
  {
    name: 'Kubernetes',
    icon: 'kubernetes-plain.svg',
    description: 'Orchestrierung von Containern in der Cloud'
  },
  {
    name: 'Storyblok',
    icon: 'storyblok.svg',
    description: 'Headless CMS zur flexiblen Content-Verwaltung'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSection, { "background-style": "dark" }, {
    default: _withCtx(() => [
      _createVNode(_unref(motion).div, {
        class: "skills-header",
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => [
          _createVNode(GradientTitle, {
            text: "Meine Fähigkeiten",
            tag: "h2"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "skills-subtitle" }, "Technologien und Tools, mit denen ich arbeite", -1))
        ]),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skills, (skill, index) => {
          return _createVNode(FeatureCard, {
            key: skill.name,
            title: skill.name,
            description: skill.description,
            icon: skill.icon,
            index: index
          }, null, 8, ["title", "description", "icon", "index"])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})